// Admin allowlist for web-only admin pages (/admin/*).
//
// VITE_ADMIN_USER_IDS is PRESENTATION ONLY: it ships in the bundle and
// decides whether an admin page renders and where login sends an admin.
// Every admin action must be re-checked server-side (e.g. the
// admin-billing-mode Edge Function checks the ADMIN_USER_IDS secret).
//
// Admin status is independent of profiles.role — a player, scout or
// academy account can be an admin.

const ADMIN_USER_IDS = new Set(
  ((import.meta.env.VITE_ADMIN_USER_IDS as string | undefined) ?? "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean),
);

/** Empty/unset allowlist means nobody is an admin. */
export function isAdminUserId(userId: string | null | undefined): boolean {
  return !!userId && ADMIN_USER_IDS.has(userId.toLowerCase());
}

/** Where a web admin lands when there's no other page for their role. */
export const ADMIN_HOME_PATH = "/admin/billing";

/**
 * The admin page a login should return to, taken from the `from` that
 * RequireAuth puts on location.state. Only same-origin /admin/* paths are
 * honoured, so this can't be used as an open redirect or to change where
 * any other route's login lands.
 */
export function adminReturnPath(state: unknown): string | null {
  const from = (state as { from?: unknown } | null)?.from;
  return typeof from === "string" && from.startsWith("/admin/") ? from : null;
}
